
export const ANALYSE_PROFITABILITY_ALLOWED_ROLES = [
    "commercial_master",
    "commercial_offer_manager",
    "commercial_strategy_manager",
  ];

  /** Approver is required in addition to a commercial role (see PROFITABILITY_FLOW.md). */
  export const ANALYSE_PROFITABILITY_APPROVER_ROLE = "approver";
  export const ANALYSE_PROFITABILITY_DRAFT_STATUS = "draft";
  export const ANALYSE_PROFITABILITY_NDAC_LEAD_PRODUCT = "ndac";
  export const ANALYSE_PROFITABILITY_SUBMITTED_YES = "yes";
  

  export type AnalyseProfitabilityOffer = {
    offerStatus?: string;
    status?: string;
    lead_product?: string;
    is_submitted?: string | boolean;
  };

  export const ANALYSE_PROFITABILITY_DRAFT_MESSAGE =
    "Profitability analysis is not available for draft offers.";
  export const ANALYSE_PROFITABILITY_NOT_SUBMITTED_MESSAGE =
    "Profitability analysis is only available for submitted offers.";
  export const ANALYSE_PROFITABILITY_NOT_NDAC_MESSAGE =
    "Profitability analysis is only available for NDAC offers.";

  /** Why the offer cannot be analysed, or null when it is eligible. */
  export const getAnalyseProfitabilityBlockReason = (
    offer?: AnalyseProfitabilityOffer | null,
  ): string | null => {
    if (!offer) {
      return null;
    }

    const offerStatus = (offer.offerStatus ?? offer.status ?? "").toLowerCase();
    if (offerStatus === ANALYSE_PROFITABILITY_DRAFT_STATUS) {
      return ANALYSE_PROFITABILITY_DRAFT_MESSAGE;
    }

    const isSubmitted =
      offer.is_submitted === true ||
      String(offer.is_submitted ?? "").toLowerCase() === ANALYSE_PROFITABILITY_SUBMITTED_YES;
    if (!isSubmitted) {
      return ANALYSE_PROFITABILITY_NOT_SUBMITTED_MESSAGE;
    }

    if ((offer.lead_product ?? "").toLowerCase() !== ANALYSE_PROFITABILITY_NDAC_LEAD_PRODUCT) {
      return ANALYSE_PROFITABILITY_NOT_NDAC_MESSAGE;
    }

    return null;
  };

  /** Offer must be non-draft, submitted, and NDAC lead product. */
  export const canAnalyseProfitabilityForOffer = (
    offer?: AnalyseProfitabilityOffer | null,
  ): boolean => {
    if (!offer) {
      return false;
    }

    return getAnalyseProfitabilityBlockReason(offer) === null;
  };
